import Moment from 'moment';
import React, { useState } from 'react';
import { getCommissionStartTimestamp, isCommissionSelectable } from './CommissionUtils';


function SeceltaCommissione(props) {

  const [selContract, setSelContract] = useState(null);

  function handleChooseContract() {
    if (selContract) props.handleChooseContract(selContract);
  }

  function onContractChanged(e) {
    const selectedContract = props.user.user.commissionList.commissions.find(function (el) {
      return el.codComm === e.currentTarget.value;
    });
    setSelContract(selectedContract);
  }

  function formatDate(value) {
    if (value === null || value === undefined || value === '') return null;
    const timestamp = Number(value);
    return Number.isFinite(timestamp) ? Moment(timestamp).format('DD/MM/YYYY') : null;
  }

  function getServices(comm) {
    const products = Array.isArray(comm.products) ? comm.products : [];
    return {
      visible: products.slice(0, 3),
      remaining: Math.max(products.length - 3, 0)
    };
  }

  return (
    <div className="iol-checkout-left-part col-xl-7 checkout-card checkout-selection-card">
      <div className="iol-select-activity-wrapper">
        <div className="iol-select-activity-title semibold">Seleziona tra le tue attività</div>
        <p className="iol-select-activity-help caption">Scegli il contratto sul quale vuoi effettuare l'acquisto.</p>
        {props.user && props.user.user && props.user.user.commissionList
          && props.user.user.commissionList.commissions
          && props.user.user.commissionList.commissions.map((comm, index) => {
            const inputId = `commission-${index}`;
            const selectable = isCommissionSelectable(comm);
            const selected = selContract && selContract.codComm === comm.codComm;
            const start = getCommissionStartTimestamp(comm);
            const services = getServices(comm);

            return <label
              className={`iol-activity${selected ? ' iol-activity--selected' : ''}${!selectable ? ' iol-activity--disabled' : ''}`}
              htmlFor={inputId} key={comm.codComm}>
              <span className="iol-radio-activity">
                <input id={inputId} name="sceltaCommissione" className="iol-radio" type="radio"
                  value={comm.codComm} onChange={onContractChanged} disabled={!selectable} />
              </span>
              <span className="iol-activity-text">
                <span className="iol-activity-heading">
                  <span className="iol-activity-title semibold">{comm.desc || `Contratto ${comm.codComm}`}</span>
                  {!selectable && <span className="iol-activity-status">Non ancora attiva</span>}
                </span>
                <span className="iol-activity-meta caption">
                  <span className="iol-activity-code">Codice contratto: {comm.codComm}</span>
                  {comm.category && <span className="iol-activity-category">Categoria: {comm.category}</span>}
                </span>
                <span className="iol-activity-dates caption">
                  {formatDate(comm.signed) && <span>Sottoscritto il {formatDate(comm.signed)}</span>}
                  {start !== null
                    && <span>{selectable ? 'Decorrenza' : 'Disponibile dal'} {formatDate(start)}</span>}
                  {formatDate(comm.end) && <span>Scadenza {formatDate(comm.end)}</span>}
                </span>
                {services.visible.length > 0
                  && <span className="iol-activity-services" aria-label="Servizi associati">
                    {services.visible.map((product, productIndex) => <span className="iol-activity-service"
                      key={`${comm.codComm}-${product.code || productIndex}`} title={product.code}>
                      {product.name || product.code}
                    </span>)}
                    {services.remaining > 0
                      && <span className="iol-activity-service">+{services.remaining} altri</span>}
                  </span>}
              </span>
            </label>;
          })}
      </div>
      <button className="fucsia-button semibold" type="button" disabled={!selContract}
        onClick={handleChooseContract}>Conferma e procedi</button>
    </div>
  );
}

export default SeceltaCommissione;
